import { render, staticRenderFns } from "./addFeeDiscount.vue?vue&type=template&id=5ff0fcf7"
import script from "./addFeeDiscount.vue?vue&type=script&lang=js"
export * from "./addFeeDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports